import { createModal } from "@stainless-code/react-modal-manager";
import { TrashIcon, TriangleAlertIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useDeleteCollectionItems } from "@/hooks/use-delete-collection-items";
import type { Collections } from "@/types/pocketbase.ts";
import {
	AlertDialog,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";

type Item = {
	collection: Collections;
	id: string;
};

type Props = {
	items: Array<Item>;
	onSuccess?: () => void;
};

export const deleteCollectionItemModal = createModal<Props>((props) => {
	const { t } = useTranslation();
	const { mutate, isPending } = useDeleteCollectionItems();

	const onDelete = () => {
		mutate({
			items: props.items,
			onSuccess: () => {
				props.close();
				props.onSuccess?.();
			},
		});
	};

	return (
		<AlertDialog open={true}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle className="inline-flex items-center gap-2">
						<TriangleAlertIcon />
						{t(($) => $.common.components.confirmDialog.delete.title)}
					</AlertDialogTitle>
					<AlertDialogDescription>{t(($) => $.common.components.confirmDialog.delete.message)}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<Button disabled={isPending} onClick={props.close} variant="outline">
						{t(($) => $.common.actions.cancel)}
					</Button>
					<Button disabled={isPending} onClick={onDelete} variant="destructive">
						<TrashIcon className="mr-2" size={16} /> {t(($) => $.common.actions.delete)}
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
});
